import { CircularProgress } from "@mui/material";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { getChatUi, sendChatMessageService, fileUploadService } from "../Services/interceptorServices";
import { Dropzone } from "dropzone";
import { API_BASE_URL } from '../helpers/constant';

Dropzone.autoDiscover = false;

let intervalId;
const Chat = ({ eventDetail, callAlert }) => {

    const { participantId, booth_language_id, participant_type, enableTextChat } = useSelector((state) => state.connection);
    const [showAllMessage, setShowAllMessage] = useState(false);
    const [logs, setLogs] = useState({
        unread_alert_count: 0,
        entries: []
    });
    const [boothName, setBoothName] = useState("English");
    const [selectedBooth, setSelectedBooth] = useState(0);
    const [message, setMessage] = useState("");
    const [loadMessage, setLoadMessage] = useState(false);


    useEffect(() => {
        return () => {
            clearInterval(intervalId);
        }
    }, []);

    const getUi = useCallback(() => {
        // callAlert();
        let last_read_timestamp_value = localStorage.getItem("last_read_timestamp_value");


        getChatUi({
            participant_id: participantId,
            last_read_timestamp: last_read_timestamp_value || ""
        }).then(resp => {
            if (resp && resp.data && resp.data.code === 200) {
                setLogs(resp.data.data);
                localStorage.setItem("last_read_timestamp", resp.data.data.last_read_timestamp);

                if (resp.data.data && resp.data.data.entries && resp.data.data.entries.length > 0) {
                    let chatLogs = resp.data.data.entries;
                    for (let chatLog of chatLogs) {
                        if (chatLog.is_alert === 1 && chatLog.is_read === 0) {
                            let timestamp = localStorage.getItem("last_alert_timestamp");

                            if (!timestamp) {
                                // callAlert();
                                localStorage.setItem("last_alert_timestamp", chatLog.timestamp);
                                return false;
                            }
                            let timestampInMs = Date.parse(timestamp) / 1000;
                            let chatLogTimestampInMs = Date.parse(chatLog.timestamp) / 1000;
                            if (timestamp && timestampInMs < chatLogTimestampInMs) {
                                callAlert();
                                localStorage.setItem("last_alert_timestamp", chatLog.timestamp);
                                return false;
                            }

                        }
                    }
                    let existTimestamp = localStorage.getItem("last_alert_timestamp");
                    if (!existTimestamp) {
                        localStorage.setItem("last_alert_timestamp", resp.data.data.last_read_timestamp || "2022-11-25 08:54:23");
                    }

                }

            }

        }).catch(err => {
            console.log("***ERR**", err);
        }).finally(() => {
            setLoadMessage(false);
        });
    }, [callAlert]);



    useEffect(() => {
        setLoadMessage(true);
        const getChatFromServer = () => {
            intervalId && clearInterval(intervalId);

            intervalId = setInterval(() => getUi(), 2000);
        };

        getChatFromServer();
    }, []);

    const getFileFromPasteEvent = (event) => {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;
        for (let index in items) {
            const item = items[index];
            if (item.kind === 'file') {
                return item.getAsFile();
            }
        }
    }

    const acceptCallback = useCallback((file) => {
        let reader = new FileReader();
        reader.onload = function (event) {
            let imageData = event.target.result;
            document.getElementById('chat-spinner').style.display = "block";
            fileUploadService({
                participant_id: participantId,
                recipient: document.getElementById("chat-recipient").getAttribute("slectedValue"),
                data: imageData
            }).then((resp) => {
                if (resp && resp.data && resp.data.code === 200) {
                    setMessage("");
                    document.getElementById('activity-log').scrollTo(0, 0);

                }
            }).catch((err) => {
                console.log("***err***", err);
            }).finally(() => {
                document.getElementById('chat-spinner').style.display = "none";
            });
        };
        reader.readAsDataURL(file);
    }, [selectedBooth])

    useEffect(() => {
        new Dropzone("textarea#chat-input", {
            method: "POST",
            url: API_BASE_URL + "/api/chat-upload",
            headers: {
                'token': "abc123",
                'Accept': "application/json, text/plain, */*",
                'Cache-Control': null,
                'X-Requested-With': null
            },
            paramName: "photo",
            uploadMultiple: false,
            maxFilesize: 10,
            acceptedFiles: 'image/*',
            addRemoveLinks: false,
            dictDefaultMessage: '',
            clickable: false,
            accept: acceptCallback
        });

    }, []);

    useEffect(() => {
        if (eventDetail && eventDetail.languages) {
            setBoothName(eventDetail.languages[1] || "English");
            if (participant_type === "moderator") {
                setSelectedBooth(booth_language_id || "-7");
            }
            if (participant_type === "client" || participant_type === "interpreter") {
                setSelectedBooth(booth_language_id || "-2");
            }
        }
    }, [booth_language_id, eventDetail]);



    const getBooths = () => {
        if (eventDetail && eventDetail.languages) {

            let sortedLanguages = Object.values(eventDetail.languages).map(value => value).sort();

            return sortedLanguages.map((booth, index) => {
                let id = Object.keys(eventDetail.languages).find((key) => {
                    return eventDetail.languages[key] === booth;
                });
                if (id == 1) {
                    return <Fragment key={index}></Fragment>
                }
                let optionProps = {}
                if (selectedBooth === id) {
                    optionProps.defaultValue = "selected";
                }
                return <option key={index} value={id} {...optionProps} >{booth}</option>
            });
        }
        return <Fragment></Fragment>

    }


    const onKeyDown = (event) => {
        // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event

        if (event.key === 'Enter' && !!message.trim() && message.trim() !== "") {
            event.preventDefault();
            event.stopPropagation();

            // Call api call here to send message
            document.getElementById('chat-spinner').style.display = "block";
            sendChatMessageService({
                participant_id: participantId,
                recipient: selectedBooth,
                content: message.trim()
            }).then((resp) => {
                if (resp && resp.data && resp.data.code === 200) {
                    setMessage("");
                    document.getElementById('activity-log').scrollTo(0, 0);

                }
            }).catch((err) => {
                console.log("***err***", err);
            }).finally(() => {
                document.getElementById('chat-spinner').style.display = "none";
            });
        }
    }


    const handlePaste = (event) => {
        const file = getFileFromPasteEvent(event);
        if (!file) { return; }

        console.log("***FILE***", file);
        const reader = new FileReader();

        reader.addEventListener("load", () => {
            // convert image file to base64 string

            document.getElementById('chat-spinner').style.display = "block";
            fileUploadService({
                participant_id: participantId,
                recipient: selectedBooth,
                data: reader.result
            }).then((resp) => {
                if (resp && resp.data && resp.data.code === 200) {
                    setMessage("");
                    document.getElementById('activity-log').scrollTo(0, 0);

                }
            }).catch((err) => {
                console.log("***err***", err);
            }).finally(() => {
                document.getElementById('chat-spinner').style.display = "none";
            });

        }, false);

        if (file) {
            reader.readAsDataURL(file);
        }

        // Call api call here to send message


    }

    let chatProps = {}
    if (enableTextChat === false) {
        chatProps.disabled = "disabled";
    }

    return (
        <div className="sticky-top">
            <div className="card">
                <div className="p-1 bg-light border-bottom" style={{ borderRadius: 3 }}>
                    {/* <!-- display when there are no alerts pending --> */}
                    {logs.unread_alert_count === 0 &&
                        <div id="pending-alerts-0" className="text-light text-center">
                            No pending alerts
                        </div>
                    }

                    {/* <!-- display when alerts are pending --> */}
                    {logs.unread_alert_count > 0 && !showAllMessage &&
                        <div id="pending-alerts-1" >
                            <div className="d-flex justify-content-around">
                                <div className="p-1 fs-chat fw-chat fs-chat-t">
                                    You have
                                    <div id="alerts-badge" className="badge badge-pill badge-warning" style={{ fontSize: "0.8rem", margin: 2 }}>{logs.unread_alert_count}</div>
                                    unread messages<span id="alert-or-alerts"></span>
                                </div>
                                <button className="btn btn-primary btn-sm" onClick={() => {
                                    setShowAllMessage(true);
                                }}>
                                    Review
                                </button>
                            </div>
                        </div>
                    }

                    {/* <!-- display when pending alerts are being displayed --> */}
                    {logs.unread_alert_count > 0 && showAllMessage &&
                        <div id="pending-alerts-2" >
                            <button className="btn btn-primary btn-sm btn-block"
                                onClick={() => {
                                    setShowAllMessage(false);
                                    let api_last_read_timestamp = localStorage.getItem("last_read_timestamp");
                                    localStorage.setItem("last_read_timestamp_value", api_last_read_timestamp);
                                }}
                            >
                                <i className="fa-solid fa-arrow-left fa-sm mr-2"></i>
                                All Messages
                            </button>
                        </div>
                    }
                </div>

                <div className="card-body p-1">
                    <div id="activity-log" style={{ height: "65vh", overflow: "auto" }}>
                        <div className="list-group list-group-flush" id="topMessage">
                            {loadMessage &&
                                <div className="p-2 text-center" >
                                    <CircularProgress />
                                </div>
                            }

                            {logs.entries.length > 0 &&
                                logs.entries.map((log, index) => (
                                    <div key={index + index} className={`list-group-item p-2 m-1 border ${log.is_alert == 0 ? "not-alert" : ""} ${(showAllMessage && log.is_alert == 0) ? " d-none" : " "} ${(log.posted_by.toLowerCase() === "me" || log.posted_by === "Technician [Me]") ? "" : ""}`}>
                                        <div className="">
                                            <div className="p-2 border-bottom text-center" id="chat-spinner" style={{ display: "none" }}>
                                                <div id="spinner">
                                                    <CircularProgress />
                                                </div>
                                            </div>
                                            <div className="p-1 fs-chat fw-chat">
                                                <div className="text-muted small float-right fs-chat">
                                                    {log.relative_timestamp}
                                                </div>
                                                <div>
                                                    <span className={"fw-chat"}>{log.posted_by}</span>
                                                    <i className="text-muted mx-1 fa-solid fa-arrow-right fa-xs ">
                                                    </i>{log.posted_to}
                                                </div>
                                            </div>
                                            <div>
                                                <div className={`chat-bubble fs-chat fw-chat ${(log.posted_by.toLowerCase() === "me" || log.posted_by === "Technician [Me]") ? " border bg-light bg-light-c" : (log.is_alert > 0 ? "bg-warning" : "bg-success")} ${log.is_read > 0 ? " opacity-5" : ""}`}>
                                                    {(!log.image_url) ? log.message :
                                                        <div>
                                                            <div className={`chat-bubble ${(log.posted_by.toLowerCase() === "me" || log.posted_by === "Technician [Me]") ? "" : "bg-success"}  `} onClick={() => {
                                                                document.getElementById("chatImageFile").setAttribute("src", log.image_url);
                                                            }} >
                                                                <a data-bs-toggle="modal" data-bs-target="#imageModal">
                                                                    <img src={log.thumbnail_url} alt="Preview" className={"img-fluid"} />
                                                                    <div className="mt-1 font-italic img-label">Click to enlarge</div>
                                                                </a>

                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                {!!log.note &&
                                                    <div className="fs-chat fw-chat" style={{ marginLeft: 8, color: "red" }}>
                                                        {log.note}
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>

                <div id="chat-form">
                    <div id="chat-dd">
                        <h4 className="chat-send-to">Send to <span><i className="mx-1 fa-solid fa-arrow-right fa-xs "></i></span></h4>
                        <select id="chat-recipient" selectedvalue={selectedBooth} value={selectedBooth} className="custom-select send-to bg-light bg-lighter border border-dark"
                            onChange={(e) => {
                                setSelectedBooth(e.target.value);
                            }}
                        >
                            <optgroup label="Chat to...">
                                {participant_type === "moderator" && <option value="-7">All</option>}
                                <option value="-2">Interpreters</option>
                                <option value="-1">Technicians</option>
                                <option value="-4">Clients</option>
                            </optgroup>
                            <optgroup label="Booths...">
                                {getBooths()}
                            </optgroup>
                            <optgroup label="If occupied...">
                                <option value={1} defaultValue={selectedBooth == 1 ? "selected" : ""} >{boothName} Booth</option>
                            </optgroup>
                        </select>
                    </div>
                    <textarea id="chat-input" {...chatProps} onPaste={handlePaste} onKeyDown={onKeyDown} value={message} className={`form-control form-control-sm mt-2 w-100 border border-dark ${enableTextChat === true ? "bg-light bg-lighter" : "bg-disabled"}`} placeholder={enableTextChat === true ? "Text message or paste your screenshot here" : "Chat is disabled for this event"} onChange={(e) => { setMessage(e.target.value) }}></textarea>
                </div>



            </div >
        </div >

    )
}

export default Chat;